/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".yesButton[_ngcontent-%COMP%]{margin:0;left:20%;position:absolute}.noButton[_ngcontent-%COMP%]{margin-left:0!important;left:55%;position:absolute}"];
export { styles as styles };
